import { createContext } from 'react';

export const InsightParamsContext = createContext({
    insightParams: {},
    setInsightParams: (val) => {},
});